module.exports = __webpack_public_path__ + "img/moldes-service.30498857.png";